import DataTable from '@/containers/data_table_ml/DataTable';
import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';
import { fieldPackageStatus } from '@/constants.js';
import Action from '../action/Action';

import { history } from 'umi';
const TablePage = (props) => {
  const { loadingstatus, tableData, fetchData } = props || {};
  const toDetail = (id, name) => {
    history.push({
      pathname: '/bre/fm/cfpm_detail',
      query: {
        id,
        name,
      },
    });
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      align: 'center',
    },
    {
      title: '字段包名',
      dataIndex: 'name',
      key: 'name',
      // width: 200,
      render: (text, record) => (
        <TableLinkML
          text={text}
          handleClick={() => toDetail(record.id, text)}
        />
      ),
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      // width: 150,
    },
    {
      title: '状态',
      dataIndex: 'fieldPackageStatus',
      key: 'fieldPackageStatus',
      // width: 100,
      render: (text) => {
        return fieldPackageStatus[text];
      },
    },
    {
      title: '操作',
      render: (record) => {
        return <Action singleListInfo={record} fetchData={fetchData} />;
      },
      width: 350,
    },
  ];
  return (
    <DataTable
      className="demo-test"
      columns={columns}
      rowSelection={false}
      // pagination={pagination}
      scroll={{
        y: 'calc(100vh - 64px - 46px - 47px - 60px - 2rem)',
      }}
      loading={loadingstatus}
      dataSource={tableData ? tableData : []}
      // changePage={(a) => {
      //   props.pageNumChange(a);
      // }}
      // changePageSize={(a) => {
      //   props.pageSizeChange(a);
      // }}
    />
  );
};
export default TablePage;
